import {Component, ChangeDetectionStrategy} from '@angular/core';
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";

@Component({
  selector: 'app-login-failed',
  imports: [
    MatProgressSpinnerModule,
  ],
  templateUrl: './login-failed.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './login-failed.component.css'
})
export class LoginFailedComponent {

}
